import { HomeContext, HomeSettings } from '@/contexts/home/helpers';
import { useContext } from 'react';

const useHome = () => useContext<HomeSettings>(HomeContext);

export default useHome;
